const accountingES = {
    "view": {
        "table": {
            "title": "Lista de Contabilidad",
            "column": {
                "release": "Lanzamiento",
                "period": "Período",
                "royalties": "Regalías",
                "costs": "Costos",
                "net_revenue": "Ingresos Netos",
                "status": "Estado",
                "accounting_report": "Informe de Contabilidad",
                "details": "Detalles"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "button": {
                "statusCreating": "Creando",
                "statusGenerating": "Generando",
                "statusGenerated": "Generado",
                "statusNotGenerated": "No Generado",
                "open": "Abrir",
                "downloadPDF": "Descargar PDF",
                "generatingPDF": "Generando PDF",
                "exportCsv": "Exportar CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor, <1>actualiza</1> tu plan de suscripción para disfrutar de esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filtros",
                "monthRange": "Rango de Meses",
                "release": "Lanzamiento"
            },
            "options": {
                "allReleases": "Todos los Lanzamientos"
            },
            "placeholder": {
                "startingMonth": "Mes de Inicio",
                "endingMonth": "Mes de Fin"
            },
            "button": {
                "generate": "Generar Informe de Contabilidad",
                "reset": "Restablecer Filtros"
            },
            "table": {
                "title": "Ganancias disponibles para contabilidad",
                "columns": {
                    "month": "Mes",
                    "year": "Año",
                    "revenue": "Ingresos",
                    "status": "Estado"
                },
                "label": {
                    "status_open": "Abierto",
                    "status_accounted": "Contabilizado",
                    "month_january": "Enero",
                    "month_february": "Febrero",
                    "month_march": "Marzo",
                    "month_april": "Abril",
                    "month_may": "Mayo",
                    "month_june": "Junio",
                    "month_july": "Julio",
                    "month_august": "Agosto",
                    "month_september": "Septiembre",
                    "month_october": "Octubre",
                    "month_november": "Noviembre",
                    "month_december": "Diciembre"
                }
            }
        },
        "modal": {
            "header": "Agregar Contabilidad",
            "body": "¿Estás seguro de que deseas agregar nueva contabilidad para el Lanzamiento: {{release}}, PERÍODO: {{startingMonth}} A {{endingMonth}}?"
        },
        "message": {
            "success": "¡La contabilidad ha sido creada!",
            "errorSomethingWentWrong": "¡Algo salió mal! Por favor, actualiza la página e intenta de nuevo.",
            "errorNoEarningsAvailable": "No hay ganancias disponibles para contabilidad.",
            "errorNoReleaseSelected": "Por favor, selecciona un lanzamiento particular para contabilidad."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Desglose de Contabilidad",
                "column": {
                    "revenueShareHolder": "Accionista",
                    "revenue": "Regalía Neta del Accionista",
                    "reportPdf": "Descargar PDF",
                    "action": "Acción",
                    "emailSent": "Correo Enviado"
                },
                "label": {
                    "downloadPDF": "Descargar PDF",
                    "generatingPDF": "Generando PDF"
                },
                "button": {
                    "exportCsv": "Exportar CSV"
                },
                "modal": {
                    "confirm": {
                        "header": "Enviar Informe al Accionista",
                        "body": "¿Estás seguro de que deseas enviar el informe al accionista?",
                        "message": {
                            "success": "¡Informe enviado con éxito!"
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar"
                        }
                    }
                },
                "message": {
                    "success": "¡El informe de contabilidad ha sido enviado!",
                    "errorSomethingWentWrong": "¡Algo salió mal! Por favor, actualiza la página e intenta de nuevo.",
                    "errorEmailNotPresent": "¡Correo electrónico del accionista no presente!",
                    "errorNoReportAvailable": "No hay informe disponible para este lanzamiento."
                }
            }
        }
    }
};

export default accountingES;